import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
    if (s > $(".section1").offset().top - $(".nei-banner").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };

$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > $(".section1").offset().top - $(".nei-banner").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})
 

$(".section3 ul li").hover(function(){
    $(this).addClass("active1").siblings().addClass("active2");
},function() {
    $(".section3 ul li").removeClass("active1");
    $(".section3 ul li").removeClass("active2");
})


var logo = new Swiper(".section6 .mySwiper", {
    slidesPerView: 5.5,
    centeredSlides: true,
    speed:4000,//匀速时间
    loop:true,
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 5.5,
            spaceBetween: 24,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 4,
            spaceBetween: 14,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    },

});

var Workshop = new Swiper(".section7 .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 24,
    pagination: {
        el: ".section7 .swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    speed:800,
    grid: {
        rows: 2,
        fill: 'column'
    },
  breakpoints: {
    // 屏幕宽度小于 600px 时，展示 1 列
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
      grid: {
        rows: 1,
        fill: 'row'
      },
    },
    // 屏幕宽度小于 1024px 时，展示 2 列
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
    // 屏幕宽度大于 1024px 时，展示 5 列
    1025: {
      slidesPerView: 3,
      spaceBetween: 24,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
  },
});
